import React from 'react';

export default function PageNotFound() {
    return (
        <div>
            <h2>no match ho</h2>
        </div>
    );
};
